import { useRef } from 'react';
import useIsomorphicEffect from '../../internal/useIsomorphicEffect';
/**
 *
 * @see https://sail.stripe.me/apis/react/usePrevious
 */ export default function usePrevious(/** The value to be remember for the next execution. */ value) {
    const valueRef = useRef(undefined);
    useIsomorphicEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    // eslint-disable-next-line react-hooks/refs
    return valueRef.current;
}

//# sourceMappingURL=usePrevious.js.map